import styled from 'styled-components';

export const DropdownRow = styled.div<{
  width: number;
}>`
  align-items: center;
  color: ${({ theme }) => theme.gray2D};
  cursor: pointer;
  display: inline-flex;
  font-family: 'Mulish', sans-serif;
  height: 32px;
  overflow: hidden;
  padding: 0 12px;
  width: ${({ width }) => (Number.isNaN(width) ? 0 : width - 60)}px;
  &:hover {
    background: ${({ theme }) => theme.grayF0};
    border-radius: 10px;
  }
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.gray4D};
  cursor: pointer;
  font-size: 16px;
  overflow: hidden;
  padding-left: 10px;
  text-overflow: ellipsis !important;
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.grayB8};
  display: flex;
  font-family: 'Mulish', sans-serif;
  font-size: 16px;
  height: 32px;
  justify-content: flex-start;
  overflow: hidden;
  padding: 0 12px;
  white-space: nowrap;
`;
